import { useEffect, useState } from 'react';

import axios from '../utils/axios';


const sideNavLenderInvite = (hasRequestNewUserFlag) => {
  const [requests, setRequests] = useState([]);

  const fetchRequests = async () => {
    if (!hasRequestNewUserFlag) {
      setRequests([]);
      return;
    }
    try {
      const response = await axios({
        url: `${baseURL}/requests/invite-lender-user`,
        method: 'GET',
      });
      setRequests(response.data || []);
    } catch (error) {
      console.error(error.response);
      setRequests([]);
    }
  };

  useEffect(() => {
    fetchRequests();
    window.addEventListener(
      'lenderInviteRequestsUpdated',
      fetchRequests,
    );
    return () => {
      window.removeEventListener(
        'lenderInviteRequestsUpdated',
        fetchRequests,
      );
    };
  }, [hasRequestNewUserFlag]);

  return {
    requests,
    hasRequests: requests.length > 0,
  };
};


export default sideNavLenderInvite;
